import * as React from 'react';
import { fetchApi } from '../../services/api';
import { formatNumber } from '@progress/kendo-intl';
import { Button } from '@progress/kendo-react-buttons';

type State = {
  loading: boolean;
  quoteCount: UserQuoteCountResponse;
  error?: string;
}

type Props = {
  filter: { Name: string, Filter: string };
}

export type UserQuoteCountResponse = Array<{ FullName: string, Count: number }>;

export default class UserQuoteCount extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      quoteCount: [],
    }

    this.refreshData = this.refreshData.bind(this);
  }

  public componentDidMount() {
    this.refreshData();
  }

  public refreshData() {
    fetchApi(`/api/Report/QuoteCountToday/${this.props.filter.Filter}`)
      .then((response: UserQuoteCountResponse) => {
        this.setState({
          loading: false,
          quoteCount: response,
          error: undefined,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error?.detail || 'Failed to load data'
        });
      });
  }

  public render() {
    if (this.state.loading) {
      return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card"></div>;
    }

    if (this.state.error) {
      return (
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card text-center p-3">
          <p style={{ color: '#d32f2f', marginBottom: '10px' }}>{this.state.error}</p>
          <Button onClick={this.refreshData} fillMode='flat'>
            Retry
          </Button>
        </div>
      );
    }

    return <React.Fragment>
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card">
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Quoted By</th>
                <th style={{ textAlign: 'right' }}>Count</th>
              </tr>
            </thead>
            <tbody>
              {this.state.quoteCount.map((data, index) => {
                return <tr key={index}>
                  <td>{data.FullName}</td>
                  <td style={{ textAlign: 'right' }}>{formatNumber(data.Count, "n0")}</td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </React.Fragment>
  }
}
